import "../../styles/AuthStyles/SideBanner.css";
import logo from "../../assets/images/Logos/kole-medical-emblem.svg";
import logoTitle from "../../assets/images/Logos/kole-medical-wordmark.svg";

interface SideBannerProps {
  isLogin: boolean;
  onSwitch: () => void;
}

export default function SideBanner({ isLogin, onSwitch }: SideBannerProps){

    return (
        <section className={`sideBanner ${isLogin ? "show-right" : "show-left"}`}>
            <div className="row-1">
                <img src={logo} alt="" />
                <div className="col-2">
                    <img src={logoTitle} alt="Kole Medical" />
                    <h3>SAHPRA Licensing Portal</h3>
                    <p>Securely apply and track your medical device licence.</p>
                </div>
            </div>
            <div className="row-2">
                <ul className="col-1">
                    <li>Track application progress</li>
                    <li>Secure client portal</li>
                    <li>Real-time updates</li>
                </ul>
                <div className="col-2">
                     <h1>{isLogin ? "Login" : "Register"}</h1>
                    <hr />
                    <hr />
                     <button className="bannerBtn" onClick={onSwitch}>
          {isLogin ? "Create Account" : "Sign In"}
        </button>
                </div>
            </div>
        </section>
    );
};
